import { render, staticRenderFns } from "./IndexTranscription.vue?vue&type=template&id=8d44e5d2&"
import script from "./IndexTranscription.vue?vue&type=script&lang=ts&"
export * from "./IndexTranscription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports